import { render } from "./AllApprovalPendingCases.vue?vue&type=template&id=5ea24f32"
import script from "./AllApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./AllApprovalPendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/AllApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ea24f32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ea24f32', __exports__)) {
    console.log('reload')
    api.reload('5ea24f32', __exports__)
  }
  
  module.hot.accept("./AllApprovalPendingCases.vue?vue&type=template&id=5ea24f32", () => {
    console.log('re-render')
    api.rerender('5ea24f32', render)
  })

}


export default __exports__